import React from 'react';
import { Container, Typography, Paper, Box, List, ListItem, ListItemIcon, ListItemText, Divider, Link, Button } from '@mui/material';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';
import PanToolIcon from '@mui/icons-material/PanTool';
import StraightenIcon from '@mui/icons-material/Straighten';
import InfoIcon from '@mui/icons-material/Info';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const sources = [
  {
    label: "BG Verkehr – Ergonomie am Fahrerarbeitsplatz",
    url: "https://www.bg-verkehr.de/arbeitssicherheit-gesundheit/ergonomie-am-fahrerarbeitsplatz"
  },
  {
    label: "DEKRA – Ratgeber Sitzposition",
    url: "https://www.dekra.de/de/sitzposition-im-auto/"
  }
];

const Driving_Position = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/user_manuals')}
        sx={{ mb: 3 }}
      >
        Zurück zum Handbuch
      </Button>
      <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <DirectionsBusIcon color="primary" sx={{ fontSize: 40 }} />
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            Richtige Sitzposition am Lenkrad für Busfahrer
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Eine korrekte Sitzposition am Lenkrad ist entscheidend für die Sicherheit, den Komfort und die Gesundheit von Busfahrern. Sie hilft, Ermüdung und Rückenbeschwerden zu vermeiden und sorgt für optimale Kontrolle über das Fahrzeug.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <List>
          <ListItem>
            <ListItemIcon>
              <AirlineSeatReclineNormalIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Sitzhöhe und Abstand"
              secondary="Stellen Sie die Sitzhöhe so ein, dass Ihre Oberschenkel leicht aufliegen und Sie die Pedale vollständig durchdrücken können, ohne sich zu strecken. Der Abstand zum Lenkrad sollte so gewählt werden, dass Ihre Arme leicht angewinkelt sind (ca. 120° Winkel)."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <PanToolIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Handhaltung am Lenkrad"
              secondary="Halten Sie das Lenkrad mit beiden Händen im Bereich '9 und 3 Uhr'. So haben Sie die beste Kontrolle und können im Notfall schnell reagieren."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <StraightenIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Rückenlehne und Lordosenstütze"
              secondary="Die Rückenlehne sollte so eingestellt sein, dass Ihr Rücken vollständig anliegt und Sie aufrecht sitzen. Nutzen Sie die Lordosenstütze, um den unteren Rücken zu entlasten."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <InfoIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Spiegel und Sicht"
              secondary="Stellen Sie alle Spiegel so ein, dass Sie einen optimalen Überblick über den Verkehrsraum haben, ohne sich zu verdrehen."
            />
          </ListItem>
        </List>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Tipp: Kontrollieren Sie regelmäßig Ihre Sitzposition und passen Sie sie bei längeren Fahrten oder Fahrerwechseln an.
        </Typography>
      </Paper>
      <Paper elevation={1} sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
          Quellen / Sources:
        </Typography>
        <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
          {sources.map(src => (
            <li key={src.url}>
              <Link href={src.url} target="_blank" rel="noopener">
                {src.label}
              </Link>
            </li>
          ))}
        </ul>
      </Paper>
    </Container>
  );
};

export default Driving_Position;